module.exports = __webpack_public_path__ + "assets/img/thumb-Australian-Institute-of-Fitness-Website.ac38cbf8.webp";